import { CircularProgress, Divider, Grid, Typography } from '@mui/material';
import { OfferResponse } from '../../sic-lib/api/offers/types/offerResponse';
import AxiosErrorAlert from '../Shared/Alerts/AxiosErrorAlert';
import { OfferAuth } from './OfferAuth';
import { OfferDetails } from './OfferDetails';

interface Props {
    isOfferLoading: boolean;
    offerData: OfferResponse | undefined;
    isOfferSuccess: boolean;
    offerError: unknown;
}

export function OfferContainer({ isOfferLoading, offerData, isOfferSuccess, offerError }: Props) {
    if (isOfferLoading) {
        return (
            <Grid
                container
                justifyContent="center"
                flexDirection="column"
                alignItems="center"
                spacing={4}
                p={4}
            >
                <Grid item>
                    <CircularProgress />
                </Grid>
                <Grid item>
                    <Typography>Loading Offer</Typography>
                </Grid>
            </Grid>
        );
    }

    if (!offerData || !isOfferSuccess || offerError) {
        return (
            <Grid item>
                {!!offerError && <AxiosErrorAlert error={offerError} />}
                {!offerError && <Typography>Unable to Load Offer</Typography>}
            </Grid>
        );
    }

    return (
        <Grid container flexDirection="row" justifyContent="center">
            <OfferDetails offer={offerData} />
            <Divider orientation="vertical" flexItem sx={{ mr: '-1px' }} />
            <OfferAuth />
        </Grid>
    );
}
